import { Box, Container, styled, Typography } from '@mui/material';
import { palette } from 'assets/styles/colors';
import ZIconTerms from 'assets/icons/ZIconTerms';

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin: 36px 120px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    margin: 72px 384px;
  }

  h2 {
    align-items: start;
  }
`;

export const Subtitle = styled(Typography)`
  margin-top: 1rem;
  align-self: start;
`;

export const StyledBackground = styled(Box)`
  background-color: ${palette.neutral[50]};
  border-radius: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Bubble = styled(ZIconTerms)`
  width: 150px;
  height: 200px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 200px;
    height: 250px;
  }
`;
